import { useState, useCallback } from 'react';
import { readingPracticeRequestsService } from '../../../services/request-service';

export const useRetryReadingPractice = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const retryPractice = useCallback(async (id) => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await readingPracticeRequestsService.retryRequest(id);
      setData(result);
      return result;
    } catch (err) {
      setError(err.message || 'Failed to retry reading practice');
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { retryPractice, isLoading, error, data };
};
